<header class="text-gray-600 body-font pt-[40px] pb-5 w-full flex flex-row justify-between px-[200px] gap-[20px] relative">
  <!-- LOGO -->
  <a class="flex title-font font-medium items-center text-gray-900">
    <img src="/assets/logo_blue_dark.svg" alt="Logo" class="w-[185px]" id="logo" />
  </a>

  <!-- Botão hamburguer (visível em telas pequenas) -->
  <button class="md:hidden text-3xl" (click)="toggleMenu()">
    <i class="bx bx-menu"></i>
  </button>

  <!-- Menu desktop -->
  <nav id="navdesktop"
    class="hidden md:flex container flex-wrap p-5 flex-col md:flex-row items-center w-fit bg-[#FDF0D5] rounded-[24px] shadow-lg shadow-indigo-500/40 justify-center">
    <nav class="md:ml-auto md:mr-auto flex items-center text-base justify-center text-center">
      <ng-container *ngIf="!isLoggedIn">
        <a class="mr-5 hover:text-red-700 border-b-2 border-transparent hover:border-[#C1121F]" [routerLink]="['/']"
          routerLinkActive="text-red-700 border-[#C1121F]">
          <i class='bx bx-home-alt-2'></i> Home
        </a>
      </ng-container>

      <ng-container *ngIf="isLoggedIn">
        <a class="mr-5 hover:text-red-700 border-b-2 border-transparent hover:border-[#C1121F]" [routerLink]="['/home']"
          routerLinkActive="text-red-700 border-[#C1121F]">
          <i class='bx bx-home-smile'></i> Home
        </a>
      </ng-container>

      <a class="mr-5 hover:text-red-700 border-b-2 border-transparent hover:border-[#C1121F]"
        [routerLink]="['/questions']" routerLinkActive="text-red-700 border-[#C1121F]">
        <i class='bx bx-extension'></i> Questões
      </a>

      <a class="mr-5 hover:text-red-700 border-b-2 border-transparent hover:border-[#C1121F]"
        [routerLink]="['/study-environment/exams-view']" routerLinkActive="text-red-700 border-[#C1121F]">
        <i class='bx bx-rocket'></i> Simulados
      </a>

      <a class="mr-5 hover:text-red-700 border-b-2 border-transparent hover:border-[#C1121F]"
        [routerLink]="['/news']" routerLinkActive="text-red-700 border-[#C1121F]">
        <i class='bx bx-news'></i> Notícias
      </a>

      <a class="mr-5 hover:text-red-700 border-b-2 border-transparent hover:border-[#C1121F]"
        [routerLink]="['/my-space/profile']" routerLinkActive="text-red-700 border-[#C1121F]">
        <i class='bx bx-user'></i> Perfil
      </a>
    </nav>
  </nav>

  <!-- Ações -->
  <div class="px-10 gap-4 hidden md:flex" *ngIf="!isLoggedIn">
    <a class="inline-flex py-2 px-5 items-center border-2 border-[var(--lightBlue)] bg-[var(--lightBlueBk)] hover:bg-white rounded-lg"
      [routerLink]="['/login']">
      Entrar <i class='bx bx-log-in ml-2'></i>
    </a>

    <a class="inline-flex py-2 px-5 items-center bg-[var(--lightRed)] hover:bg-red-600 text-white font-medium rounded-lg"
      [routerLink]="['/signup']">
      Assinar agora
    </a>
  </div>

  <div class="px-10 gap-4 hidden md:flex" *ngIf="isLoggedIn">
    <a class="inline-flex py-2 px-5 items-center text-red-600" (click)="logout()">
      Sair <i class='bx bx-exit ml-2'></i>
    </a>
  </div>

  <!-- MENU MODAL MOBILE -->
  <div *ngIf="menuOpen" class="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-start justify-end">
    <div class="w-2/3 bg-white h-full p-6 space-y-6">
      <button class="text-3xl mb-4" (click)="toggleMenu()">
        <i class="bx bx-x"></i>
      </button>

      <ng-container *ngIf="!isLoggedIn">
        <a class="block text-lg" routerLink="/" (click)="toggleMenu()">🏠 Home</a>
      </ng-container>
      <ng-container *ngIf="isLoggedIn">
        <a class="block text-lg" routerLink="/home" (click)="toggleMenu()">🏠 Home</a>
      </ng-container>

      <a class="block text-lg" routerLink="/questions" (click)="toggleMenu()">📄 Questões</a>
      <a class="block text-lg" routerLink="/study-environment/exams-view" (click)="toggleMenu()">🚀 Simulados</a>
      <a class="block text-lg" routerLink="/news" (click)="toggleMenu()">📰 Notícias</a>
      <a class="block text-lg" routerLink="/my-space/profile" (click)="toggleMenu()">👤 Perfil</a>

      <hr />

      <div *ngIf="!isLoggedIn" class="flex flex-col gap-4">
        <a class="block text-lg text-blue-600 font-semibold" routerLink="/login" (click)="toggleMenu()">Entrar</a>
        <a class="block text-lg text-white bg-red-600 text-center py-2 rounded" routerLink="/signup"
          (click)="toggleMenu()">Assinar agora</a>
      </div>

      <div *ngIf="isLoggedIn">
        <a class="block text-lg text-red-600" (click)="logout()">Sair</a>
      </div>
    </div>
  </div>
</header>
